import HeaderBar from "../../../components/header/headerBar";
import MainButton from "../../../components/button/mainButton";
import { Icon } from "@iconify/react";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { CopyFilled } from "@ant-design/icons";
import "../../../assets/styles/admin/branchEdit.scss";
import { getFileHostUrl } from "../../../helpers/functions";
import { getLocalUrl } from "../../../functions";

import {
  Row,
  Col,
  Input,
  Upload,
  Form,
  Space,
  Button,
  Tooltip,
  Image,
  message,
  Typography,
} from "antd";
import axios from "axios";

interface ParamsType {
  id: string;
}

const BranchesEdit = () => {
  const { id } = useParams<ParamsType>();
  const history = useHistory();
  let [formBranchEdit] = Form.useForm();
  const { Text } = Typography;

  const fileInput: any = useRef();
  const [uploadFile, setUploadFile] = useState<any>("");

  const [isHidel, setIsHeidel] = useState<boolean>(false);
  const [validate, setValidate] = useState<boolean>(false);
  const [readOnly, setReadOnly] = useState<boolean>(true);
  const [state, setState] = useState<any>({});
  const [pathBranch, setPathBranch] = useState<any>("");

  const [filePic, setFilePic] = useState<any>([]);
  const [isDisable, setIsDisable] = useState<any>([]);

  const onUploadIconClick = () => {
    console.log("click...");
    fileInput.current.click();
  };

  const onFileInputChange = (e: any) => {
    console.log("e change pic =>", e.file);
    const { originFileObj } = e.file;

    const url = getLocalUrl(originFileObj);
    if (e.file.status !== "removed") {
      setFilePic([
        {
          uid: "1",
          name: e?.file?.name,
          url: url,
        },
      ]);
    } else {
      formBranchEdit.setFieldsValue({ uploadId: null });
      setFilePic([]);
    }
  };

  const getAPIs = async () => {
    console.log("id", id);

    setIsDisable({
      ...isDisable,
      isUpload: true,
    });

    await axios.get(`branches/${id}`).then((res) => {
      // console.log("res.data.data =>", res?.data?.data);
      const datas = res?.data?.data;
      setPathBranch(datas?.name);

      formBranchEdit.setFieldsValue({
        code: datas?.code,
        name: datas?.name,
        nameEN: datas?.nameEN,
        taxNumber: datas?.taxNumber,
        phone: datas?.phone,
        fax: datas?.fax,
        googleMap: datas?.googleMap,
        address: datas?.address,
        addressEN: datas?.addressEN,
        uploadId: datas?.photoURL,
      });

      const imageUrl = getFileHostUrl(datas?.photoURL);

      setFilePic([
        {
          uid: "1",
          name: res?.data?.data?.photoURL,
          status: "done",
          url: imageUrl,

          response: '{"status": "success"}',
        },
      ]);

      setState(res?.data?.data);
    });
  };

  const UpdateData = async (values: any) => {
    // console.log("UPDATE SUCCESS !", values._id);
    console.log("values", values);
    try {
      await axios.patch(`/branches/${id}`, {
        code: values?.code,
        name: values?.name,
        nameEN: values?.nameEN,
        taxNumber: values?.taxNumber,
        phone: values?.phone,
        fax: values?.fax,
        googleMap: values?.googleMap,
        address: values?.address,
        addressEN: values?.addressEN,
      });
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };
      // console.log("data", Datas?.file?.fileList?.originFileObj);
      const fmData = new FormData();
      if (values?.uploadId?.fileList) {
        fmData.append("file", values?.uploadId?.fileList[0]?.originFileObj);
        await axios.patch(
          `/branches/upload-file?uploadId=${id}`,
          fmData,
          config
        );
      }
      message.success("บันทึกสำเร็จ/Save Success");
      setTimeout(() => {
        history.push(`/setting/branches`);
      }, 500);
    } catch (error) {
      console.log("error", error);
    }
  };
  const onKeydownCheck = (eveb: KeyboardEvent) => {
    console.log("e event", eveb.which);

    if (eveb.which !== 8 && eveb.which !== 67) {
      eveb.preventDefault();
    }
    // message.error("Please Input Max 10 ");
  };

  const onHideChange = () => {
    setIsHeidel(!isHidel);
    setValidate(!validate);
    setReadOnly(!readOnly);
    getAPIs();
  };

  useEffect(() => {
    getAPIs();
  }, []);

  const Onsubmit = (values: any) => {
    if (values) {
      UpdateData(values);
    }
  };

  return (
    <div>
      {/* {console.log("branch", pathBranch)} */}
      <HeaderBar title={"BRANCHES / " + pathBranch} btnBack={true}>
        <MainButton
          title="Edit"
          className="mg-10"
          onClick={onHideChange}
          background={isHidel === true ? "#AED0D0" : "#4D7E7F"}
        >
          <Icon
            icon="ant-design:edit-filled"
            width="24"
            height="24"
            color="#ffff"
          />
        </MainButton>
      </HeaderBar>
      <Form form={formBranchEdit} onFinish={Onsubmit} layout="vertical">
        <div style={{ padding: "30px 50px" }}>
          <div className="create-page" style={{ padding: "30px 20px" }}>
            <Row justify="space-around" className="form-branchEdit">
              <Col span={7}>
                <Form.Item
                  name="code"
                  label="Branch Code"
                  rules={[
                    {
                      required: validate,
                      message: "Please input your Branch Code!",
                    },
                  ]}
                >
                  <Input type="text" disabled={true} />
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item
                  name="name"
                  label="Branch Name (THAI)"
                  rules={[
                    {
                      required: validate,
                      message: "Please input your Branch Name (THAI)!",
                    },
                  ]}
                >
                  <Input type="text" readOnly={readOnly} />
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item
                  name="nameEN"
                  label="Branch Name (ENG)"
                  rules={[
                    {
                      required: validate,
                      message: "Please input your Branch Name (ENG)!",
                    },
                  ]}
                >
                  <Input type="text" readOnly={readOnly} />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="space-around" className="form-branchEdit">
              <Col span={7}>
                <Form.Item
                  name="taxNumber"
                  label="Tax ID Number"
                  rules={[
                    {
                      required: validate,
                      message: "Please input your Tax ID Number!",
                    },
                  ]}
                >
                  <Input type="number" readOnly={readOnly} />
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item
                  name="phone"
                  label="Tel."
                  rules={[
                    {
                      required: validate,
                      message: "Please input your Tel.!",
                    },
                  ]}
                >
                  <Input
                    type="tel"
                    readOnly={readOnly}
                    onKeyDown={(e: any) => {
                      if (e.target.value.length >= 10) {
                        onKeydownCheck(e);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item
                  name="fax"
                  label="Fax."
                  rules={[
                    {
                      required: validate,
                      message: "Please input your Fax!",
                    },
                  ]}
                >
                  <Input type="number" readOnly={readOnly} />
                </Form.Item>
              </Col>
            </Row>
            <Row className="form-branchEdit">
              <Col span={20} style={{ marginLeft: "20px" }}>
                <Form.Item
                  name="googleMap"
                  label="Location link (Google map)"
                  rules={[
                    {
                      required: validate,
                      message: "Please input your Location link (Google map)!",
                    },
                  ]}
                >
                  <Input type="text" readOnly={readOnly} />
                </Form.Item>
              </Col>
              <Col span={3} style={{ padding: "0px 20px", marginTop: "55px" }}>
                <Tooltip title="COPY Location link (Google map)">
                  <Button
                    icon={
                      <Icon
                        icon="fluent:document-copy-48-filled"
                        width="25"
                        height="20"
                        color="#5baea9"
                      />
                    }
                    style={{
                      color: "#5baea9",
                      width: "100px",
                      height: "37px",
                      borderColor: "#5BAEA9",
                      borderRadius: "5px",
                    }}
                    // onClick={(e) => Oncopy(e)}
                    onClick={() => {
                      navigator.clipboard.writeText(state?.googleMap);
                      message.success("Your Copied");
                    }}
                  >
                    COPY
                  </Button>
                </Tooltip>
              </Col>
            </Row>
            <Row className="form-branchEdit">
              <Col span={23} style={{ marginLeft: "20px" }}>
                <Form.Item
                  name="address"
                  label="Branch Address (THAI)"
                  rules={[
                    {
                      required: validate,
                      message: "Please input your Branch Address (THAI)!",
                    },
                  ]}
                >
                  <Input type="text" readOnly={readOnly} />
                </Form.Item>
              </Col>
            </Row>
            <Row className="form-branchEdit">
              <Col span={23} style={{ marginLeft: "20px" }}>
                <Form.Item
                  name="addressEN"
                  label="Branch Address (ENG)"
                  rules={[
                    {
                      required: validate,
                      message: "Please input your Branch Address (ENG)!",
                    },
                  ]}
                >
                  <Input type="text" readOnly={readOnly} />
                </Form.Item>
              </Col>
            </Row>

            <Row style={{ marginTop: "10px", marginLeft: "20px" }}>
              <Form.Item
                name="uploadId"
                label="Branch Picture"
                rules={[
                  {
                    required: true,
                    message: "Please input your Picture Branch !",
                  },
                ]}
                className="branch-pic"
              >
                <Upload
                  listType="picture-card"
                  onChange={(e) => {
                    onFileInputChange(e);
                  }}
                  customRequest={({ onSuccess }: any) => {
                    onSuccess();
                  }}
                  fileList={filePic}
                  accept="image/*"
                  disabled={readOnly}
                >
                  {filePic?.length < 1 && (
                    <div className="icon-upload">
                      <Icon
                        icon="bxs:image-add"
                        width="1.5rem"
                        height="1.5rem"
                        style={{ marginLeft: "5px" }}
                      />
                    </div>
                  )}
                </Upload>
              </Form.Item>
            </Row>
          </div>
        </div>
        {isHidel === true ? (
          <Row
            className="button-branchedit"
            justify="center"
            style={{ marginTop: "5px" }}
          >
            <Col>
              <Space>
                <Button
                  onClick={() => {
                    history.push(`/setting/branches`);
                    formBranchEdit.resetFields();
                  }}
                  className="cancleButton-branchedit"
                >
                  ยกเลิก/Cancel
                </Button>
                <Button className="confirmButton-branchedit" htmlType="submit">
                  บันทึกข้อมูล/Submit
                </Button>
              </Space>
            </Col>
          </Row>
        ) : (
          ""
        )}
      </Form>
    </div>
  );
};
export default BranchesEdit;
